import { render, staticRenderFns } from "./SmsTemplateDataTable.vue?vue&type=template&id=335cd0a9&scoped=true"
import script from "./SmsTemplateDataTable.vue?vue&type=script&lang=js"
export * from "./SmsTemplateDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335cd0a9",
  null
  
)

export default component.exports